<template>
    <div class="notes">
        <div class="loading" v-if="loading"><div class="loader"></div></div>
        <div class="input" v-if="isOpen">
            <textarea name="notes" autocomplete="off" id="notes-input" @input="resize"  v-model="note" rows="1" v-bind:placeholder="placeholder"></textarea>
            <div style="margin-top:12px;" v-if="note != '' && actions">
                <a href="" v-bind:class="postButtonColor" @click.prevent="addNote" class="button tiny" v-html="postButton"></a>&nbsp;
                <a href="" @click.prevent="cancelNote" class="basic lighten">Cancel</a>
            </div>
        </div>
        <div class="note" :data-id="note.id" v-for="(note,index) in notes">
            <div class="flex" v-if="note.creator">
                <div>
                    <img v-bind:src="note.creator.avatar" height="25" width="25" class="rounded" />
                </div>
                <div class="note-header">
                    <div class="name" v-html="note.creator.name"></div>
                    <div class="lighten date" v-html="note.created"></div>
                </div>
                <div class="flex-filler"></div>
                <div class="edit-icon" v-if="note.editable">
                    <a href="" class="basic" style="opacity:0.2;">
                        <span @click.prevent="deleteNote(index)" v-if="note.confirm == undefined" class="material-icons">delete_outline</span>
                        <div  v-if="note.confirm != undefined" class="confirm-delete">
                            <div>
                                <a @click.prevent="confirmDeleteNote(index)" href="">Delete</a>&nbsp;
                                <a class="basic lighten" @click.prevent="cancelDeleteNote(index)" href="">Cancel</a>
                            </div>
                        </div>
                    </a>
                </div>
            </div>
            <div v-bind:class="{ bordered : note.type == 'bordered' }">
                <div v-bind:class="note.noteClass">
                    <div v-bind:class="{ 'flex-center' : note.icon != undefined }">
                        <div v-if="note.icon != undefined">
                            <span class="material-icons" style="font-size:25px;" v-html="note.icon"></span>
                        </div>
                        <div class="message" v-html="note.note"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    module.exports = {
        created: function () {
            this.isOpen = this.open;
        },
        data:function() {
            return {
                note:'',
                loading:false,
                isOpen:true,
                postButton:"Post",
                postButtonColor:""
            }
        },
        props:{
            notes:{ type:Array },
            placeholder:{type:String,default:'Add notes or comments'},
            open:{ type:Boolean,default:true },
            save:{ type:String,default:'' },
            actions:{type:Boolean,default:true }
        },
        methods: {
            addNote:function() {
                this.isOpen = false;
                this.loading = true;
                if(this.save != '') {
                    var e = this;
                    $.ajax({
                        type:'PATCH',
                        url:this.save,
                        data: {
                            note:this.note
                        },
                        success:function(response) {
                            e.loading = false;
                            e.isOpen = true;
                            if(response.status == 200) {
                                var data = response.data;
                                e.note = '';
                                if(e.notes != undefined) {
                                    e.notes.unshift(data);
                                }
                                if(data.refresh != undefined) {
                                    e.$refresh();
                                }
                                if(data.timeline != undefined) {
                                    $.get('/projects/' + data.timeline,function(timeline) {
                                        $('.timeline').html('<div id="modal-render-timeline"></div>');
                                        var res = Vue.compile(timeline.content)
                                        var vm = new Vue({
                                            el:'#modal-render-timeline',
                                            render: res.render,
                                            staticRenderFns: res.staticRenderFns
                                        });
                                    });
                                } else if(data.usertimeline != undefined) {
                                    $.get('/users/' + data.usertimeline + '/timeline',function(timeline) {
                                        $('.timeline').html('<div id="modal-render-timeline"></div>');
                                        var res = Vue.compile(timeline.content)
                                        var vm = new Vue({
                                            el:'#modal-render-timeline',
                                            render: res.render,
                                            staticRenderFns: res.staticRenderFns
                                        });
                                    });
                                }
                            } else {
                                e.postButtonColor = 'red';
                                e.postButton = response.msg;
                                setTimeout(function() {
                                    e.postButtonColor = '';
                                    e.postButton = 'Post';
                                },1000);
                            }
                        },
                        error:function(response) {
                            e.loading = false;
                            e.isOpen = true;
                            var error = response.responseJSON
                            var message = 'An error occurred';
                            if(error.errors) {
                                message = error.errors.note[0];
                            }
                            e.postButtonColor = 'red';
                            e.postButton = message;
                            setTimeout(function() {
                                e.postButtonColor = '';
                                e.postButton = 'Post';
                            },1000);
                        }
                    });
                } else {
                    console.log('Please set a save destination in the `save` prop');
                }
            },
            deleteNote:function(index) {
                this.notes[index].confirm = true;
                this.$forceUpdate();
            },
            confirmDeleteNote:function(index) {
                if(this.save != '') {
                    var e = this;
                    $.ajax({
                        type: 'DELETE',
                        url:this.save,
                        data: {
                            note:this.notes[index].id
                        },
                        success(response) {
                            if(response.status == 200) {
                                e.notes.splice(index,1);
                                e.$forceUpdate();
                                if(response.data.refresh != undefined) {
                                    e.$refresh();
                                }
                            } else {
                                alert(response.msg);
                            }
                        }
                    })
                } else {
                    console.log('Please set a delete destination in the `save` prop');
                }
            },
            cancelDeleteNote:function(index) {
                delete this.notes[index].confirm;
                this.$forceUpdate();
            },
            cancelNote:function() {
                this.note = '';
                $(this.$el).find('textarea').css('height','20px');
            },
            resize(event) {
                event.target.style.height = "auto";
                event.target.style.height = (event.target.scrollHeight - 26) + 'px';
            }
        },
        mounted:function() {
        }
    }
</script>
